<template>
  <div class="login" @keyup.13="login">
    <div class="login-wrapper">
      <div class="tooltip-wrapper">
        <div class="tooltip">
          {{ qrLogin ? '帐号密码登录' : '扫码登录' }}
        </div>
      </div>
      <img
        src="~assets/img/qrcodelogin.png"
        class="login-way-img"
        v-if="passwordLogin"
        @click="changeLoginWay"
      />
      <img
        src="~assets/img/passwordlogin.png"
        class="login-way-img"
        v-if="qrLogin"
        @click="changeLoginWay"
      />
      <div class="title">请先登录</div>
      <mu-form label-width="60" :model="form" v-show="passwordLogin">
        <mu-form-item prop="userName" label="用户名">
          <mu-text-field v-model="form.userName"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="password" label="密码">
          <mu-text-field
            v-model="form.password"
            type="password"
          ></mu-text-field>
        </mu-form-item>
        <mu-form-item class="btns">
          <mu-button color="secondary">注册</mu-button>
          <mu-button color="primary" @click="login">登录</mu-button>
        </mu-form-item>
      </mu-form>
      <div class="qr-login" v-show="qrLogin">
        <img :src="codeSrc" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import { mapActions } from 'vuex'
// import QRCode from 'qrcode'
import io from 'socket.io-client'
export default {
  data() {
    return {
      qrLogin: true,
      passwordLogin: false,
      form: {
        userName: '',
        password: ''
      },
      socketId: '',
      codeSrc: ''
    }
  },
  methods: {
    ...mapActions(['setUser', 'setMenuTree']),
    login() {
      backend(api.auth.login, this.form).then((result) => {
        if (result.statusCode === 200) {
          this.setUser(result.data)
          const menuTree = result.data.role.menus.filter(
            (x) => x.menuLevel === '一级'
          )
          this.setMenuTree(menuTree)
          this.$router.replace('/admin')
        }
      })
    },
    qrcodeInit(socketId) {
      backend(api.wechat.getWeappCode, { scene: socketId }).then((result) => {
        if (result.statusCode === 200) {
          this.codeSrc = `data:image/png;base64,${result.data}`
        }
      })
    },
    changeLoginWay() {
      this.passwordLogin = !this.passwordLogin
      this.qrLogin = !this.qrLogin
    },
    wsInit() {
      return new Promise((resolve) => {
        const socket = io()
        socket.on('connect', () => {
          resolve(socket.id)
          socket.on('qrcodeLoginSuccess', (result) => {
            if (result.statusCode === 200) {
              const uuid = result.data.uuid
              backend(api.auth.qrLogin, { uuid }).then((res) => {
                if (res.statusCode === 200) {
                  this.$toast.success('登录成功')
                  this.setUser(result.data.user)
                  const menuTree = result.data.user.role.menus.filter(
                    (x) => x.menuLevel === '一级'
                  )
                  this.setMenuTree(menuTree)
                  this.$router.replace('/admin')
                }
              })
            }
          })
        })
      })
    }
  },
  mounted() {
    this.wsInit().then((socketId) => {
      this.qrcodeInit(socketId)
    })
  }
}
</script>

<style lang="less">
.login {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  .login-wrapper {
    position: relative;
    width: 360px;
    padding: 30px;
    background: #fff;
    margin: 200px auto;
    border-radius: 4px;
    .tooltip-wrapper {
      top: 10px;
      left: 0;
      position: absolute;
      width: 100%;
      display: flex;
      justify-content: center;
      .tooltip {
        background: rgba(0, 0, 0, 0.3);
        padding: 4px 6px;
        border-radius: 4px;
        position: relative;
        color: #fff;
        &:after {
          position: absolute;
          content: '';
          display: block;
          width: 20px;
          height: 20px;
          border-width: 10px;
          border-style: solid;
          border-color: transparent transparent transparent rgba(0, 0, 0, 0.2);
          top: 5px;
          left: 100%;
        }
      }
    }
    .login-way-img {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .title {
      font-size: 24px;
    }
    .btns {
      .mu-form-item-content {
        justify-content: center;
      }
    }
  }
  .qr-login {
    width: 300px;
    height: 300px;
    display: flex;
    justify-content: center;
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/login.vue